// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-icon[data-v-a2d72d0a]{fill:currentColor}", ""]);
// Exports
module.exports = exports;
